import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario1 from "./Scenario1";
import { globals } from "../../misc/globals";

export default class Scenario1Part3 extends BaseScenarioPart<CalmBaseScenario> {

	chapterIds = {
		scenario1_3a_s7: 'CALM - Scenario 1 - 3A - Segment 7',
		scenario1_3a_s8: 'CALM - Scenario 1 - 3A - Segment 8',
		scenario1_3a_s9: 'CALM - Scenario 1 - 3A - Segment 9'
	}
	private partIndx = 2;

	constructor(scenario: Scenario1, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario1/calm-scenario1-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part3.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MarcoApproaches();
	}

	private segment1Step1MarcoApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Speak with RN Marco');
		this.playVideoChapter(this.chapterIds.scenario1_3a_s7, () => { //a.	Marco approaches and shows a drug discrepancy - to image of receipt / Response UI
			context.scenario.updateObjective('');
			context.segment2Step3ShowDiscrepancy();
		});
	}

	private segment2Step2MarcoDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		
		this.scenario.playSound('CN-C11-L1-000b', () => {
			context.segment2Step3ShowDiscrepancy();

        }, false, globals.isMuted)
	}

	private segment2Step3ShowDiscrepancy() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.update508Window(Window508Type.MedicalDispenserUI)
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.MedicalDispenserUI, {
			image: './assets/images/scenario1/med-discrepancy.png',
			onClose: () => {
				context.segment2Step4ResponseToMarcoDialogue();
			}
		})
	}

	private segment2Step4ResponseToMarcoDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		var searchTakeTooLong = 'Yikes. This is not good. We need to search the unit floor for those missing pills!';
		this.scenario.dialog(
			null,
			[{
				text: 'Well, since it’s only Tramadol, this isn’t a big deal right now. I’ll help you later.',
				feedback: 'A medication discrepancy is a very serious issue. Your staff should not be allowed to leave the facility until this discrepancy is cleared.',
				isCorrect: false,
				scoreType: ScoreType.Worst
			}, {
				text: 'Okay, thank you for letting me know. I need to alert our Nurse Manager of this discrepancy before we move forward.',
				isCorrect: true,
				scoreType: ScoreType.Best
			}, {
				text: searchTakeTooLong,
				isCorrect: true,
				scoreType: ScoreType.Ok
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				if(selectedOption.text.indexOf(searchTakeTooLong) !== -1) {
					context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step4TooLong(), context.partIndx);
				} else {
					context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1GoToNurseStation(), context.partIndx);
				}
			}
		);
	}

	private segment2Step4TooLong() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		this.playVideoChapter(this.chapterIds.scenario1_3a_s8, () => { //a.	Marco says he thinks searching the floor would take too long - to Respond UI
			context.scenario.updateObjective('');
			context.segment2Step4SearchTakeTooLongDialogue();
		});
	}

	private segment2Step4SearchTakeTooLongDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C11-L1-030a',
			[{
				text: 'You\'re right. That\'s a better idea. Thank you, Marco.',
				isCorrect: true
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				// if(context.scenario.evaluateAnswer(selectedOption)) {
					context.segment3Step1GoToNurseStation();
				// }
			}
		);
	}

	private segment3Step1GoToNurseStation() {
		this.scenario.destroyAllUIInstances();
		var context = this; 
		context.scenario.updateObjective('Enter report at the Nurse\'s Station Computer');
		context.playVideoChapter(this.chapterIds.scenario1_3a_s9, () => { //a.	Marco says great, call with nurse manager, return to PC - to Computer Report UI
			context.scenario.updateObjective('');
			context.showNurseStationComputer();
		}); 
	}

	private showNurseStationComputer() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Discrepancy Resolved: No Report Necessary<br /><br />Discrepancy Unresolved: Report Mandated'
				},
				{
					title: '24 Hour',
					description: 'A medical discrepancy occurred. The Nurse Manager was notified immediately and resolved the discrepancy.'
				},
				{
					title: 'End of Shift',
					description: 'A medical discrepancy occurred. The Nurse Manager was notified immediately and resolved the discrepancy.'
				}
			],
			review: {
				text: 
				`
				<p class="regular-description-font" style="margin: 0;">
					Narcotics or other controlled substances are at a high risk for diversion. <br /><br />

					The Charge Nurse is responsible to <span style="color: rgb(222, 225, 156)">monitor for this activity and report any findings.</span> <br /><br />

					Furthermore, you need to <span style="color: rgb(222, 225, 156)">encourage your staff to report any discrepancies</span> to you as soon as they are discovered.
				</p>
				`
			},
			reflects: [
				{
					title: 'Does your unit use a medication dispenser? Do the necessary personnel know how to properly use it?',
					answer: ''
				},
				{
					title: 'Whose role is to clear medication discrepancies in your facility?',
					answer: ''
				},
				{
					title: 'What are your facility’s policies on clearing medication discrepancies?',
					answer: ''
				},
				{
					title: 'What are the policies at your facility for missing scheduled substances? Do you notify police? Are staff asked individually or as a group to discover how the discrepancy occurred?',
					answer: ''
				},
				{
					title: 'What are some commonly administered drugs on your unit? How knowledgeable are your staff members about the effects of these drugs?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			} 
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			var badges = context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].badges;
			context.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = null;
			
			for(var indx = 0; indx < badges.length; indx++) {
				badges[indx].isUnlocked = true;
			}
			context.scenario.gameManager.UiManager.destroyAllInstances();
			context.scenario.unlockNextLevel();
			context.scenario.update508Window(Window508Type.EndLevelUI);
			context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.EndLevelUI, {
				level: context.scenario.currentLevel,
				badges: badges,
				onExitGameClicked: () => {
					context.scenario.exitGame();
				},
				onNextLevelClicked: () => {
					context.scenario.nextLevel();
					context.onDone();
				}
			});
		});
	}
}